import React from 'react'

const Rightabout = ({image,heading, text}) => {
  return (
    <>
    <div className='container'>
        <div className='row'>
            <div className='col-lg-9 col-md-9 col-sm-6 col-12 '  data-aos="fade-up"  data-aos-duration="1000">
                <div className='aboutus-m'>
                    <h4>{heading}</h4>
                </div>
                <div className='aboutus-m'>
                   <p>{text}</p>
                </div>
            </div>
            <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                <img className='img-fluid updated phone-image '  data-aos="fade-down"  data-aos-duration="1000" src={image} alt=''/>
            </div>
        </div>
    </div>
    </>
  )
}

export default Rightabout
